module.exports = __webpack_public_path__ + "img/sortImg1-1-4.27d2a775.png";